import { create } from "zustand"
import {FormState, InvoiceDetailTypes} from "../types/invoiceAdjustmentTypes"

interface InvoiceAdjustmentState {
    adj_code: string
    data_invoice: InvoiceDetailTypes
    isLoading: boolean
    error: string | null
    total_detail : number
    saldo:number
    data_form: FormState

    // Action
    setAdjCode: (value: string) => void
    setDataFrom: (data_form: Partial<FormState>) => void
    setTotalDetail:(value: number) => void
    setSaldo:(value: number) => void
    setDataInvoice: (data_invoice: InvoiceDetailTypes) => void
    setLoading: (value: boolean) => void
    reset: () => void
}

//Initial state
const initialState: Omit<InvoiceAdjustmentState, 
  | "setAdjCode"
  | "setDataFrom"
  | "setTotalDetail"
  | "setSaldo"
  | "setDataInvoice"
  | "setLoading"
  | "reset"
> = {
  data_invoice: {
    invoice_id: 0,
    transaction_date: '',
    trx_code: '',
    sales_order_id: 0,
    so_code: '',
    invoice_status: '',
    invoice_status_text: '',
    customer_id: 0,
    customer_code: '',
    customer_name: '',
    employee_id: 0,
    employee_name: '',
    location_id: 0,
    location_name: '',
    freight: 0,
    total_invoice: 0,
    total_tax: 0,
    tot_payment: 0,
  },
  data_form: {
    invoice_id: 0,
    transaction_date: "",
    adj_freight: 0,
    coa_ar_credit: 0,
    coa_freight_debet: 0,
    coa_ar_credit_name: '',
    coa_freight_debet_name: '',
    employee_id: 0,
    location_id: 0,
    customer_id:0,
  },
  isLoading: true,
  error: null,
  adj_code: '',
  total_detail: 0,
  saldo: 0,
}


export const adjustmentFreightStore = create<InvoiceAdjustmentState>((set, get) => ({
   ...initialState,

    setAdjCode:(value) => set({ adj_code: value }),
    setTotalDetail:(value) => set({ total_detail: value }),
    setSaldo:(value) => set({ saldo: value }),
    setDataInvoice: (data_invoice) => set({ data_invoice }),
    setLoading: (value) => set({ isLoading: value }),
    setDataFrom: (data_form) =>
        set((state) => ({
            data_form: { ...state.data_form, ...data_form },
        })
    ),

    reset: () => set(() => ({ ...initialState })),
}))